import { useEffect, useRef, useState } from "react";
import { Loader2, CheckCircle2, AlertTriangle, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const QUEUE_HINT = "L'agente di stampa del negozio la stamperà tra pochi secondi.";
const VIEW = {
  pending: { icon: Loader2, spin: true, cls: "bg-slate-50 border-slate-200 text-slate-700", title: "Ricevuta in coda di stampa…", hint: QUEUE_HINT },
  printing: { icon: Loader2, spin: true, cls: "bg-slate-50 border-slate-200 text-slate-700", title: "Ricevuta in stampa…", hint: QUEUE_HINT },
  done: { icon: CheckCircle2, cls: "bg-emerald-50 border-emerald-200 text-emerald-800", title: "Ricevuta stampata", hint: "Ritira la ricevuta dalla stampante." },
  failed: { icon: AlertTriangle, cls: "bg-red-50 border-red-200 text-red-800", title: "Stampa non riuscita", hint: "La stampante non ha risposto." },
};

export function PrintJobStatus({ playId, active, onRetry, onDone }) {
  const [job, setJob] = useState(null);
  const doneNotified = useRef(false);
  useEffect(() => {
    if (job?.status === "done" && !doneNotified.current) {
      doneNotified.current = true;
      onDone?.();
    }
  }, [job?.status, onDone]);
  useEffect(() => {
    if (!active) return;
    let stop = false;
    const tick = () => api.printJobByPlay(playId).then((j) => { if (!stop) setJob(j); }).catch(() => {});
    tick();
    const t = setInterval(() => {
      if (job?.status === "done") return;
      tick();
    }, 2500);
    return () => { stop = true; clearInterval(t); };
  }, [playId, active, job?.status]);

  if (!active || !job) return null;
  const s = job.status;
  const v = VIEW[s] || VIEW.pending;
  const Icon = v.icon;
  return (
    <div className={`flex items-center gap-3 rounded-xl border px-4 py-3 text-sm ${v.cls}`} data-testid="print-job-status" data-status={s}>
      <Icon className={`h-5 w-5 shrink-0 ${v.spin ? "animate-spin" : ""}`} />
      <div className="flex-1">
        <p className="font-semibold">{v.title}</p>
        <p className="text-xs opacity-80">{s === "failed" ? job.error || v.hint : v.hint}</p>
      </div>
      {s === "failed" && (
        <Button size="sm" variant="outline" className="gap-1.5 border-red-300 text-red-700" data-testid="print-job-retry-button" onClick={() => api.printJobRetryByPlay(playId).then(() => { setJob({ ...job, status: "pending", error: null }); onRetry?.(); })}>
          <Printer className="h-3.5 w-3.5" /> Riprova
        </Button>
      )}
    </div>
  );
}
